import { InteractionPage } from '@/components/InteractionPage';

export default InteractionPage;
